import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { UntypedFormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { AbstractControlDirective } from '@supoui/shared/components/abstract-control.directive';
import { APP_MAT_DATE_FORMAT } from '@supoui/shared/components/input-calendar/format-datepicker';
import moment from 'moment';
import {provideMomentDateAdapter} from "@angular/material-moment-adapter";

@Component({
    selector: 'app-input-date-picker',
    templateUrl: './input-date-picker.component.html',
    styleUrls: ['./input-date-picker.component.scss'],
    providers: [
      provideMomentDateAdapter(APP_MAT_DATE_FORMAT),
        {
            provide: NG_VALUE_ACCESSOR,
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            useExisting: forwardRef(() => InputDatePickerComponent),
            multi: true
        }
    ],
    standalone: false
})
export class InputDatePickerComponent extends AbstractControlDirective {
  public dateControl: UntypedFormControl = new UntypedFormControl();

  @Input() withImage: boolean;
  @Input() placeholder = '';
  @Input() invalid = false;
  @Input() touchUi = false;
  @Input() useNative = false;
  @Input() minDate: Date | null;
  @Input() maxDate: Date | null;

  @Output() dateChanged: EventEmitter<Date> = new EventEmitter<Date>();

  constructor(private dateAdapter: DateAdapter<Date>) {
    super();
    this.dateAdapter.getFirstDayOfWeek = () => {
      return 1;
    };
    this.subscriptions.push(
      this.dateControl.valueChanges.subscribe(value => {
        if (value) {
          if (moment.isDate(value)) {
            value = moment(value).utc(true).startOf('day').toDate();
          } else {
            value = value.utc(true).startOf('day').toDate();
          }
        }
        this.onChange(value);
        this.onTouched();
        this.dateChanged.emit(value);
      })
    );
  }

  public writeValue(value: string | null): void {
    value = value ? value : null;
    if (value) {
      value = moment.utc(value)?.format('YYYY-MM-DD');
    }
    this.dateControl.patchValue(value, { emitEvent: false });
  }

  public setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.dateControl.disable({ emitEvent: false });
    } else {
      this.dateControl.enable({ emitEvent: false });
    }
  }
}
